<template>
  <div class="classMange">
    <router-view v-if="this.$route.path != '/courseContent/ClassMange'" />
    <div
      id="classmanagement"
      style="height:100%"
      v-else
      class="classmanagement"
    >
      <div class="nav-header">
        <li>
          <one-button @click="receiveimport">
            <span class="iconfont icon-jiahao" />
            {{ $t('translateText.ClassMange.drbj') }}
          </one-button>
          <one-button @click="receiveset">
            <a-icon type="setting" /> {{ $t('translateText.ClassMange.plsz') }}
          </one-button>
          <one-button @click="receivedelete">
            <i class="iconfont icon-shanchu1"></i>
            {{ $t('translateText.ClassMange.plyc') }}
          </one-button>
        </li>
        <li style="width: 20%">
          <search
            :placeholder="$t('translateText.ClassMange.qsr')"
            @search="onSearch"
            @zero="zero"
          ></search>
        </li>
      </div>
      <!-- 班级列表 -->
      <div class="nav-body" ref="body">
        <publictable
          ref="table"
          :columns="classtitle"
          :data2="classes"
          :edit1="editor"
          :del="delets"
          :submit="look"
          :title="$t('translateText.ClassMange.qrsc')"
          @scope="del"
          :Show="true"
          v-on:update="receive"
          v-on:submitDetail="see"
          @checkAll="checkAll"
        ></publictable>
      </div>
      <!-- 设置时间 -->
      <a-modal
        class="modal-time"
        v-model="showsettingtime"
        v-if="showsettingtime"
        @ok="handletimeOK"
        @cancel="canceltime"
        :ok-text="$t('translateText.ok')"
        :cancel-text="$t('translateText.cancel')"
      >
        <div class="setting-time">
          <div class="time-header">
            <p>{{ $t('translateText.ClassMange.sjsz') }}</p>
          </div>
          <div class="time-body">
            <p class="course-time">{{ $t('translateText.ClassMange.kcsz') }}</p>
            <div class="times">
              <a-date-picker
                class="starttimes"
                v-model="startValue"
                :disabled-date="disabledStartDate"
                show-time
                format="YYYY-MM-DD HH:mm:ss"
                :placeholder="$t('translateText.ClassMange.kssj')"
                @openChange="handleStartOpenChange"
              />
              <p class="zhi">{{ $t('translateText.ClassMange.to') }}</p>
              <a-date-picker
                class="endtimes"
                v-model="endValue"
                :disabled-date="disabledEndDate"
                show-time
                format="YYYY-MM-DD HH:mm:ss"
                :placeholder="$t('translateText.ClassMange.jssj')"
                :open="endOpen"
                @openChange="handleEndOpenChange"
              />
            </div>
          </div>
        </div>
      </a-modal>
      <!-- 删除班级 -->
      <s-modal
        :visible="showdeleteroles"
        @cancel="cancelFn"
        @confirm="confirmFn"
      >
        {{ $t('translateText.ClassMange.qrscgbj') }}
      </s-modal>
      <!-- 导入班级 -->
      <a-modal
        class="modal-class"
        v-model="showimportclass"
        @ok="handleOk"
        @cancel="canceledit"
        :ok-text="$t('translateText.ok')"
        :cancel-text="$t('translateText.cancel')"
      >
        <div class="importclass" v-if="showimportclass == true">
          <div class="import-header">
            <p>{{ $t('translateText.ClassMange.drbj') }}</p>
          </div>
          <div class="import-body">
            <p class="select-class">
              {{ $t('translateText.ClassMange.xzbj') }}
            </p>
            <div class="headers class-select">
              <a-select
                :placeholder="$t('translateText.ClassMange.qxzbj')"
                showSearch
                optionFilterProp="children"
                v-model="category"
                :maxTagCount="multipleMaxCount"
                @change="categoryChange"
                mode="multiple"
                style="width: 100%; border-radius: 4px"
              >
                <a-select-option value="0" key="0" v-if="ListShow">{{
                  $t('translateText.ClassMange.all')
                }}</a-select-option>
                <a-select-option value="1" key="1" v-else>{{
                  $t('translateText.ClassMange.noall')
                }}</a-select-option>

                <a-select-option
                  v-for="importclass in importclasses"
                  :value="importclass.key"
                  :key="importclass.key"
                  >{{ importclass.strClassName }}
                  <!-- {{ importclass.number }}人 -->
                </a-select-option>
              </a-select>
            </div>
            <div>
              <p class="studytime">{{ $t('translateText.ClassMange.xxsj') }}</p>
              <div class="times">
                <a-date-picker
                  class="starttimes"
                  v-model="startValue"
                  :disabled-date="disabledStartDate"
                  show-time
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="$t('translateText.ClassMange.kssj')"
                  @openChange="handleStartOpenChange"
                />
                <p class="zhi">{{ $t('translateText.ClassMange.to') }}</p>
                <a-date-picker
                  class="endtimes"
                  v-model="endValue"
                  :disabled-date="disabledEndDate"
                  show-time
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="$t('translateText.ClassMange.jssj')"
                  :open="endOpen"
                  @openChange="handleEndOpenChange"
                />
              </div>
            </div>
          </div>
        </div>
      </a-modal>
      <pag ref="pag" @passpage="passpage" />
    </div>
  </div>
</template>

<script>
const moment = require('moment')
import search from '@/components/search'
import pag from '@/components/pagiation'
import publictable from '@/components/Table/Table'
import sModal from '@/components/Modal/secondModal'
import {
  getAllClass,
  getPageCourseClass,
  ImportUserClass,
  removeUserClass,
  UpdateUserCourseTime,
} from '../../../../utils/api'

export default {
  name: 'ClassManagement',
  data() {
    return {
      dtEndTime: null,
      dtStartTime: null,
      editor: this.$t('translateText.cmtb.sjsz'),
      delets: this.$t('translateText.cmtb.yc'),
      look: this.$t('translateText.cmtb.ck'),
      showsettingtime: false,
      showdeleteroles: false,
      //showimportlist: false,
      startValue: null,
      endValue: null,
      endOpen: false,
      //selectArr: [],
      //classname: "",
      checked: false,
      showimportclass: false,
      showsetting: 0,
      showseeclass: '',
      selectedRowKeys: [], //选中列
      category: [],
      multipleMaxCount: 4,
      ListShow: true,
      bodyHeight: 0,
      showuser: [],
      classid: [{ iClassId: 1 }],
      searchKey: '',
      pageNumber: 1,

      classes: [],

      importclasses: [],
    }
  },
  components: {
    pag,
    publictable,
    sModal,
    search,
  },
  computed: {
    classtitle() {
      return [
        {
          title: this.$t('translateText.ClassMange.xh'),
          dataIndex: 'serialnumber',
          width: 80,
        },
        {
          title: this.$t('translateText.ClassMange.bj'),
          dataIndex: 'user.userClass.strClassName',
        },
        {
          title: this.$t('translateText.ClassMange.kksj'),
          dataIndex: 'dtStartTime',
        },
        {
          title: this.$t('translateText.ClassMange.jksj'),
          dataIndex: 'dtEndTime',
        },
        {
          title: this.$t('translateText.ClassMange.cz'),
          dataIndex: 'op',
          scopedSlots: { customRender: 'op' },
        },
      ]
    },
    importclass() {
      return [
        {
          title: this.$t('translateText.ClassMange.bj'),
          dataIndex: 'strClassName',
        },
        {
          title: this.$t('translateText.ClassMange.rs'),
          dataIndex: 'number',
        },
      ]
    },

    selectedRowKey() {
      return this.selectedRowKeys.length > 0
    },
    search() {
      return this.searchKey.length
    },
    categoryLists() {
      return this.category.length
    },
  },
  watch: {
    categoryLists(newVlaue) {
      if (newVlaue == '0') {
        this.ListShow = true
      }
    },
  },

  mounted() {
    this.getPageCourseClass()
  },
  methods: {
    //获取所有班级
    getclass() {
      let vm = this
      getAllClass({}).then((response) => {
        if (response.data.iCode == 0) {
          response.data.objData.forEach((item) => {
            vm.$set(item, 'key', item.iClassId)
          })
          vm.importclasses = response.data.objData
          for (let i = 0; i < vm.classes.length; i++) {
            for (let j = 0; j < vm.importclasses.length; j++) {
              if (
                vm.importclasses[j].iClassId ==
                vm.classes[i].user.userClass.iClassId
              ) {
                vm.importclasses.splice(j, 1)
              }
            }
          }
        } else {
          return vm.$message.error(response.data.strMessage)
        }
      })
    },
    passpage(pageNumber) {
      this.pageNumber = pageNumber
      this.getPageCourseClass()
    },
    //分页获取课程下所有班级
    getPageCourseClass() {
      var vm = this
      getPageCourseClass({
        iCourseId: localStorage.getItem('courseId'),
        strClassName: this.searchKey,
        iCurPage: this.pageNumber,
        iPageSize: 10,
      }).then(function(response) {
        if (response.data.iCode == 0) {
          vm.$refs.pag.showTotal = response.data.objData.iTotalPages * 10
          vm.$refs.pag.pageNumber = response.data.objData.iPageIndex
          sessionStorage.setItem(
            'showTotal',
            response.data.objData.iTotalPages * 10
          )
          sessionStorage.setItem('pageNumber', response.data.objData.iPageIndex)
          response.data.objData.listPage.forEach((item, index) => {
            item.dtEndTime = moment(item.dtEndTime).format(
              'YYYY-MM-DD HH:mm:ss'
            )
            item.dtStartTime = moment(item.dtStartTime).format(
              'YYYY-MM-DD HH:mm:ss'
            )
            vm.$set(item, 'serialnumber', index + 1)
            vm.$set(item, 'key', item.user.userClass.iClassId)
          })
          vm.classes = response.data.objData.listPage
        } else {
          return this.$message.error(response.data.strMessage)
        }
      })
    },
    //时间设置
    disabledStartDate(startValue) {
      const endValue = this.endValue
      if (!startValue || !endValue) {
        return false
      }
      return startValue.valueOf() > endValue.valueOf()
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
    // //时间格式转换
    // getdate(dateData) {
    //     let date = new Date(dateData);
    //     let y = date.getFullYear();
    //     let m = date.getMonth() + 1;
    //     m = m < 10 ? "0" + m : m;
    //     let d = date.getDate();
    //     d = d < 10 ? "0" + d : d;
    //     const time = y + "-" + m + "-" + d;
    //     return time;
    // },
    // 全选
    checkAll(val) {
      this.selectedRowKeys = val
    },
    categoryChange(key) {
      if (key.indexOf('0') >= 0) {
        this.category = []
        this.importclasses.forEach((item) => {
          this.category.push(item.key)
        })
        this.ListShow = false
      } else if (key.indexOf('1') >= 0) {
        this.ListShow = true
        this.category = []
      } else if (this.category.length < this.importclasses.length) {
        this.ListShow = true
      }
    },
    GiveUp() {
      this.category = []
      this.teacherName = ''
      this.introArea = ''
      this.$router.go(-1)
    },
    //删除数据
    cancelFn() {
      this.showdeleteroles = false
    },
    confirmFn() {
      let arr2 = this.selectedRowKeys.map((item) => {
        return Object.assign({}, { iClassId: item })
      })
      this.showdeleteroles = false
      var that = this
      removeUserClass({
        listUserClass: arr2,
        iCourseId: localStorage.getItem('courseId'),
      }).then(function(response) {
        var pageNum = that.$refs.pag.showTotal / 10
        if (response.data.iCode == 0) {
          if (
            pageNum == that.pageNumber &&
            that.classes.length == arr2.length
          ) {
            that.pageNumber--
            if (that.pageNumber == 0) {
              that.pageNumber = 1
            }
          }
          that.getPageCourseClass()
        } else {
          return that.$message.error(response.data.strMessage)
        }
      })
    },
    delFn() {
      this.showdeleteroles = true
    },
    del(item) {
      this.selectedRowKeys = []
      this.$refs.table.selectedRowKeys = []
      this.selectedRowKeys.push(item.user.userClass.iClassId)
      this.confirmFn()
    },
    receivedelete() {
      if (this.selectedRowKey) {
        this.showdeleteroles = true
        return false
      }
      return this.$message.error(this.$t('translateText.ClassMange.qdwxz'))
    },
    //设置时间
    receive(row) {
      this.selectedRowKeys = []
      this.endValue = moment(row.dtEndTime)
      this.startValue = moment(row.dtStartTime)
      this.$refs.table.selectedRowKeys = []
      this.selectedRowKeys.push(row.user.userClass.iClassId)
      this.showsettingtime = true
    },
    receiveset() {
      if (this.selectedRowKeys.length > 0) {
        this.showsettingtime = true
      } else {
        return this.$message.error(this.$t('translateText.ClassMange.dqwxz'))
      }
    },
    handletimeOK() {
      if(!this.startValue || !this.endValue){
        return this.$message.warning(this.$t('translateText.opLog.SelectTime'))
      }
      let arr2 = this.selectedRowKeys.map((item) => {
        return Object.assign({}, { iClassId: item })
      })
      this.showsettingtime = false
      let vm = this
      UpdateUserCourseTime({
        iCourseId: localStorage.getItem('courseId'),
        dtStartTime: moment(this.startValue).format('YYYY-MM-DD HH:mm:ss'),
        dtEndTime: moment(this.endValue).format('YYYY-MM-DD HH:mm:ss'),
        listUserClass: arr2,
      }).then(function(response) {
        if (response.data.iCode == 0) {
          vm.getPageCourseClass()
          vm.startValue = ''
          vm.endValue = ''
          vm.selectedRowKeys = []
          vm.$refs.table.selectedRowKeys = []
        } else {
          return vm.$message.error(response.data.strMessage)
        }
      })
      this.$message.success(this.$t('translateText.accountSet.ModifiedSuccessfully'))
    },
    canceltime() {
      this.showsettingtime = false
      this.selectedRowKeys = []
    },
    //导入
    receiveimport() {
      this.getclass()
      this.startValue = null
      this.endValue = null
      this.showimportclass = true
    },
    handleOk() {
      let arr2 = this.category.map((item) => {
        return Object.assign({}, { iClassId: item })
      })
      if (this.category.length <= 0) {
        return this.$message.error(this.$t('translateText.ClassMange.qxzdrbj'))
      } else if (!this.startValue  || !this.endValue) {
        return this.$message.error(this.$t('translateText.ClassMange.qxzxxsj'))
      } else {
        this.showimportclass = false
        let vm = this
        ImportUserClass({
          listUserClass: arr2,
          iCourseId: localStorage.getItem('courseId'),
          dtStartTime: moment(vm.startValue).format('YYYY-MM-DD HH:mm:ss'),
          dtEndTime: moment(vm.endValue).format('YYYY-MM-DD HH:mm:ss'),
        }).then(function(response) {
          if (response.data.iCode == 0) {
            vm.searchKey = ''
            vm.getPageCourseClass()
            vm.category = []
            vm.startValue = ''
            vm.endValue = ''
            if (response.data.objData) {
              let arr = response.data.objData.split(',')
              let tipArr = []
              vm.importclasses.forEach((item) => {
                if (arr.indexOf(String(item.iClassId)) > -1) {
                  tipArr.push(item.strClassName)
                }
              })
              console.log('tipArr', tipArr)
              if(tipArr.length > 0) {
                if (vm.$store.state.language == 'zh') {
                  vm.$message.warning(tipArr.join('，') + vm.$t('translateText.ClassMange.zwxs') + vm.$t('translateText.ClassMange.cxdr'))
                } else {
                  vm.$message.warning(vm.$t('translateText.ClassMange.zwxs') + tipArr.join('，') + vm.$t('translateText.ClassMange.cxdr'))
                }
              }
            }
          } else {
            return vm.$message.error(response.data.strMessage)
          }
        })
      }
    },
    canceledit() {
      this.showimportclass = false
    },
    //接收数据
    see(row) {
      this.$router.push({
        path: '/courseContent/ClassMange/seeClass',
        query: {
          iClassId: row.user.userClass.iClassId,
        },
      })
    },
    //搜索班级
    onSearch(val) {
      //搜索按钮的回调事件
      this.pageNumber = 1
      this.searchuser(val)
    },
    zero() {
      this.searchKey = ''
    },
    searchuser(val) {
      this.searchKey = val
      this.getPageCourseClass()
    },
  },
}
</script>

<style lang="stylus" scoped>
/deep/.ant-table-tbody > tr > td {
    padding: 9.5px 13px;
}
// .mybox-leave-active, .mybox-enter-active
// transition: all 0.4s ease
// .mybox-leave-active, .mybox-enter
// height: 0px !important
// .mybox-leave, .mybox-enter-active
// height: 150px
/deep/.ant-table-body
    max-height :470px!important
.headers
    display: inline-block
/deep/.ant-calendar-picker .ant-calendar-picker-input
    width: 170px !important
    border-radius: 0
    font-size: 14px
/deep/.ant-calendar-picker .ant-calendar-picker-icon
    right: 40px
/deep/.ant-calendar-picker-clear
    right:40px
/deep/.prompt-delete-roles
    width: 30.74%
    height: 32.95%
    top: 20%
    /deep/ .img-content
        width: 59%
.cursorpoint
    cursor: pointer
.modal-class
    /deep/.ant-modal-content
        display: inline-block
        width: 450px
        height: 300px
        margin-left: 18%
        margin-top: 18%
    /deep/ .ant-modal-footer
        border-top: none
        margin-top: 185px
    /deep/ .ant-btn-primary
        background: #2EADB5
        margin-right: 26%
        margin-left: 18%
.importclass
    position: absolute
    top: 0
    left: 50%
    transform: translateX(-50%)
    width: 100%
    height: 100%
    .import-header
        display: flex
        flex-direction: row
        margin-top: 4%
    p
        font-size: 2.15185185185vh
        color: #373737
        font-weight: 700
        margin-left: 43%
    img
        width: 12px
        height: 12px
        margin-left: 34%
.import-body
    display: flex
    position: relative
    flex-direction: column
    width: 89%
    height: 64%
    margin-top: 0
    margin-left: 5%
    .select-class
        margin-left: 1%
        margin-top: 2%
        font-weight: 400
    .class-select
        width: 98%
        height: 30px
        line-height: 30px
        font-size: 1.666666666vh
        color: #505050
        // border: 1px solid #2EADB5
        margin-left: 1%
        margin-top: 2%
        .inputclassname
            width: 100%
            height: 30px
            border: 1px solid #2EADB5
            border-radius: 4px
            outline: none
        .class-icon
            display: inline-block
            margin-left: -7%
            color: #2EADB5
    .import-inform
        display: inline-block
        width: 98%
        height: 100%
        margin-left: 1%
        margin-top: 1%
        background: #FFFFFF
        box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.16)
        border-radius: 5px
        overflow-y: auto
        overflow-x: hidden
        z-index: 999
    .allclass
        display: inline-block
        margin-top: 3%
        margin-left: 4%
        font-weight: 400
        font-size: 1.85185185185vh
    .selectall
        display: inline-block
        margin-left: 310px
    .studytime
        position: absolute
        left: -42%
        top: 49%
        font-weight: 400
    .times
        display: flex
        flex-direction: row
        // margin-top: 14%
        position: absolute
        top: 65%
        .starttimes
            width: 100px
            margin-left: 1%
        .zhi
            margin-left: -1.5%
            margin-top: 1%
            font-weight: 400
        .endtimes
            margin-left: 4%
    .importtable
        display: inline-block
        width: 100%
        margin-top: 2%
        font-size: 1.66666666vh
        .table-body
            display: inline-block
            height: 24px
            width: 380px
            line-height: 24px
            position: relative
            .classname
                margin-left: 14px
            .classnumber
                margin-left: 100px
            .selectbox
                margin-left: 130px
.modal-time
    /deep/.ant-modal-content
        display: inline-block
        width: 460px
        height: 220px
        margin-left: 18%
        margin-top: 26%
/deep/ .ant-modal-footer
    border-top: none
    margin-top: 110px
/deep/ .ant-btn-primary
    background: #2EADB5
    margin-right: 26%
    margin-left: 18%
.setting-time
    position: absolute
    top: 0
    left: 50%
    transform: translateX(-50%)
    width: 100%
    height: 100%
    .time-header
        display: flex
        flex-direction: row
        margin-top: 4.5%
    p
        font-size: 2.05185185185vh
        color: #373737
        font-weight: 700
        margin-left: 43%
.time-body
    display: flex
    flex-direction: column
    width: 100%
    margin-left: 1%
    .course-time
        margin-left: 5%
        margin-top: 4%
        font-weight: 400
    .times
        display: flex
        flex-direction: row
        margin-top: 4%
        .starttimes
            margin-left: 5%
        .zhi
            margin-left: 1%
            margin-top: 1%
            font-weight: 400
        .endtimes
            margin-left: 4%
.classMange
    position: relative
    width: 100%
    height: 101%
    background-color: #FFFFFF
    border-radius: 5px
    padding: 0 3% 0 2%
    .header-button
        width: 100%
        height: 12%
        display: flex
        justify-content: space-between
        align-items: center
        border-bottom: 2px solid #d5d5d5
    .classtable
        display: inline-block
        width: 100%
        height: 70%
        float: left
        padding-top: 1%
    .buttons
        display: flex
        flex-direction: row
        margin-top: 39%
        .concel
            color: #2eadb5
            border: 1px #2eadb5 solid
            margin-left: 23%
        .sure
            background-color: #2eadb5
            border: #2eadb5
            color: #FFFFFF
            margin-left: 23%
.nav-header
    right: 2%
    left: 2%
    height: 10%
    display: flex
    justify-content: space-between
    align-items: center
    border-bottom: 2px solid #d5d5d5
    margin-bottom: 1%
    position: absolute
    top: 0
.nav-body
    position: absolute
    top: 9%
    right: 2%
    left: 2%
    // bottom: 6%
    bottom:48px;
    overflow: auto;
.nav-body::-webkit-scrollbar {
        display: none;
        }
</style>
